import { render, staticRenderFns } from "./HiddenInput.vue?vue&type=template&id=38080b6c"
import script from "./HiddenInput.vue?vue&type=script&lang=js"
export * from "./HiddenInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports